import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../../mappers/common/common';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import { GdRecommendationStatus } from '../../../typings/graphql-grid';
import {
    Kpi,
    RecommendationCharacter,
    RecommendationType
} from '../../../typings/recommendations';
import {
    RecommendationCard,
    RecommendationCardView
} from '../../RecommendationCard/RecommendationCard';
import {
    RecommendationKpiInfo,
    RecommendationKpiType
} from '../../RecommendationKpiInfo/RecommendationKpiInfo';
import { Shape2Icon } from '../../Shape2/Shape2';

import * as keyset from './CampaignDayBudgetRecommendationCardGridPopup.i18n';

const i18n = i18nFactory(keyset);

interface CampaignDayBudgetRecommendationCardGridPopupProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    kpi: Kpi;
    status: GdRecommendationStatus;
    onAcceptClick: () => void;
    isApplicable: boolean;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export class CampaignDayBudgetRecommendationCardGridPopup extends React.PureComponent<
    CampaignDayBudgetRecommendationCardGridPopupProps
> {
    render() {
        const {
            status,
            isApplicable,
            kpi: { periodValue, clicks, cost, sign, currency },
            onShow,
            character,
            icon
        } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.dailyBudget}
                view={RecommendationCardView.recommendationsPopup}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                buttons={this.getButtons()}
                isInProgress={status === GdRecommendationStatus.IN_PROGRESS}
                isApplicable={isApplicable}
                progressHint={this.getProgressHintText()}
                onShow={onShow}
            >
                <RecommendationKpiInfo
                    currency={currency}
                    periodValue={periodValue}
                    kpi={{
                        type: RecommendationKpiType.clicks,
                        value: clicks
                    }}
                    cost={cost}
                    sign={sign}
                />
            </RecommendationCard>
        );
    }

    private getTitle = (): string => {
        const recommendedDailyBudget = [
            formatNumber(this.props.kpi.recommendedDailyBudget, 0),
            mapStringToCurrencySymbol(this.props.kpi.currency)
        ].join(' ');

        return i18n('simple-title', {
            sum: recommendedDailyBudget
        });
    };

    private getTitleHint = (): string => {
        const {
            kpi: { periodValue }
        } = this.props;

        return pluralizeWord(
            [
                i18n('one-day-title-hint', { daysNumber: periodValue }),
                i18n('some-days-title-hint', {
                    daysNumber: periodValue
                }),
                i18n('many-days-title-hint', { daysNumber: periodValue })
            ],
            periodValue
        );
    };

    private getButtons = () => {
        const props = this.props;

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                disabled={!props.isApplicable}
                onClick={props.onAcceptClick}
                text={i18n('accept-button')}
            />
        ];
    };

    private getProgressHintText = (): string => {
        return i18n('simple-progress-hint');
    };
}
